<div class="row mb-3">
  <div class="col"><span i18n class="font-weight-bold">Filters</span></div>
</div>

<div *ngFor="let filter of visibleFilters; index as i" class="row mt-2 align-items-center">
  <div class="col-3">
    <ng-select [(ngModel)]="visibleFilters[i]" (change)="onFilterTypeChange(filter)" [clearable]="false">
      <ng-option [value]="filter">{{ filter.name }}</ng-option>
      <ng-option *ngFor="let availableFilter of availableFilters" [value]="availableFilter">
        {{ availableFilter.name }}
      </ng-option>
    </ng-select>
  </div>
  <div class="col-1" i18n>Equals</div>
  <div class="col">
    <cc-form-field-analytics-filter
      class="filter-component"
      [field]="filter.item"
      [state]="filter.state"
      [options]="filter.options"
      (onChange)="onFilterChange(filter, $event)"
    ></cc-form-field-analytics-filter>
  </div>
  <div class="col-1">
    <button type="button" class="btn btn-sm btn-link sm-text-default-red" (click)="onRemoveFilter(i)">
      <i class="cc-icon cc-icon-close sm-text-default-red"></i>
    </button>
  </div>
</div>

<div class="row mt-2 align-items-center" *ngIf="newFilterIsVisible">
  <div class="col-3">
    <ng-select
      id="analytics-filter"
      [items]="availableFilters"
      bindLabel="name"
      placeholder="Select..."
      (change)="onAddFilter($event)"
    ></ng-select>
  </div>
  <div class="col-1">
    <button type="button" class="btn btn-sm btn-link sm-text-default-red" (click)="hideNewFilter()">
      <i class="cc-icon cc-icon-close sm-text-default-red"></i>
    </button>
  </div>
</div>

<div class="row mt-2" *ngIf="!emptyFilters.size && !newFilterIsVisible && availableFilters.length">
  <div class="col">
    <button type="button" class="btn btn-primary" id="add-chart-filter" (click)="showNewFilter()">Add filter</button>
  </div>
</div>
